export default "__VITE_ASSET__DF9Zm5yI__"